module.exports = __webpack_public_path__ + "fonts/CeraPro-Bold.80457e5a.woff";